import { useAuth0 } from '@auth0/auth0-vue';
import { toRaw } from 'vue';

/** Auth0 の organization/roles クレームに含まれるロール情報 */
type OrganizationRole = {
  name: string;
  description: string;
};

type LicenseAndAuthorityList = {
  licenseList: string[];
  authorityList: string[];
};

/** ログインしているユーザーが属するアカウントのIDを返す */
const getAccountId = (): string | undefined => {
  const auth0 = toRaw(useAuth0()?.user.value);
  return auth0?.organization.id;
};

/** ログインしているユーザーが属するアカウントの名前を返す */
const getAccountName = (): string => {
  const auth0User = toRaw(useAuth0()?.user);
  if (auth0User?.value) {
    return auth0User.value.organization.name;
  } else {
    return '';
  }
};

/** organization display name*/
const getAccountDisplayName = (): string => {
  const auth0User = toRaw(useAuth0()?.user);
  if (auth0User?.value) {
    return auth0User.value.organization.display_name;
  } else {
    return '';
  }
};

/** ログインしているユーザーのニックネームを返す */
const getUserNickname = (): string | undefined => {
  const auth0User = toRaw(useAuth0()?.user);
  if (auth0User?.value) {
    return auth0User.value.nickname;
  } else {
    return '';
  }
};

/**ログインしているユーザーのユーザーIDを返す */
const getUserId = (): string | undefined => {
  const auth0 = toRaw(useAuth0()?.user.value);
  return auth0?.sub;
};

const getUserRole = (): 'role-administrator' | 'role-viewer' => {
  const auth0User = toRaw(useAuth0().user?.value?.['user/roles']);
  if (auth0User && auth0User.includes('role-administrator')) {
    return 'role-administrator';
  } else {
    return 'role-viewer';
  }
};

export const getOrganizationRoleDetails = (): OrganizationRole[] => {
  const roleDetails = toRaw(useAuth0()?.user?.value?.['organization/roles']);
  return roleDetails ? roleDetails : [];
};

export const getLicenseAndAuthorityList = (): LicenseAndAuthorityList => {
  const licenseList: string[] = [];
  const authorityList: string[] = [];

  const roleDetails = getOrganizationRoleDetails();
  for (const role of roleDetails) {
    if (role.name.startsWith('license')) {
      try {
        const parsed = JSON.parse(role.description);
        const serviceId = parsed.serviceId;
        if (!licenseList.includes(serviceId)) licenseList.push(serviceId);
      } catch {
        console.error('Invalid license role description JSON:', role.name);
      }
    } else if (role.name.startsWith('authority')) {
      const id = role.name.replace(/^authority-/, ''); // removes "authority-" only from the beginning
      authorityList.push(id);
    }
  }
  return { licenseList, authorityList };
};

export default {
  getAccountId,
  getAccountName,
  getAccountDisplayName,
  getUserNickname,
  getUserId,
  getUserRole,
  getOrganizationRoleDetails,
  getLicenseAndAuthorityList,
};
